import { getUserActivate } from "../api/getUserActivate";
import { getUserDeActivate } from "../api/getUserDeActivate";
import { getUserReassignEmail } from "../api/getUserReassignEmail";
import { postUserManagerCompleteRegistration } from "../api/postUserManagerCompleteRegistration";
import { UserManagerCompleteRegistration } from "../types";

const activeUserOrDeActiveUserFunc = async (id: number, active:boolean) => {
    if(active){
        await getUserActivate(id).then(() => {
            return {
                status: "ok",
                error: ""
            }
        }).catch(err=>{
            return {
                status: "error",
                error: err
            }
        })
    }else{
        await getUserDeActivate(id).then(() => {
            return {
                status: "ok",
                error: ""
            }
        }).catch(err=>{
            return {
                status: "error",
                error: err
            }
        })
    }
};

const reassignEmailFunc = async (email: string, residentKey:string, contactKey:string) => {
    
    await getUserReassignEmail(email,residentKey,contactKey).then(() => {
        return {
            status: "ok",
            error: ""
        }
    }).catch(err=>{
        return {
            status: "error",
            error: err
        }
    })
};


const completeRegistrationFunc = async (email: string): Promise<UserManagerCompleteRegistration> => {
    try {
        const response = await postUserManagerCompleteRegistration(email);
        // API returns a structured { status, message } result (camelCase, per this app's JSON convention)
        return response.data;
    } catch (err) {
        return {
            status: 'Error',
            message: err?.response?.data?.message || "An error occurred during user registration. Try again, please."
        };
    }
};

export default { activeUserOrDeActiveUserFunc, reassignEmailFunc, completeRegistrationFunc }
